export default theme => ({
  wrapper: {
    color: '#8b8c8d',
    paddingBottom: 8,
    position: 'absolute',
    transition: 'all ease 500ms',
    top: 0,
    height: '100%',
    width: 250,
    left: props => props.isOpen ? 0 : -250,
    fontSize: 14,
    textAlign: 'right',
    background: '#e6e6e6',
  },
  fixedWrapper: {
    position: 'fixed',
    width: 250,
    height: '100%',
  },
  container: {
    width: '100%',
    background: '#fff',
    padding: '3px 15px 30px 0',
    border: '1px solid #E0E0E0',
    '-moz-box-shadow': '1px 1px 3px #F5F5F5',
    '-webkit-box-shadow': '1px 1px 3px #F5F5F5',
    boxShadow: '1px 1px 3px #F5F5F5',
    '-moz-border-radius': 2,
    '-webkit-border-radius': 2,
    borderRadius: 2,
    height: '100%',
    overflowX: 'auto'
  },
  pageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 'unset',
    height: '100%',
    background: 'hsla(0,0%,100%,.25)',
    cursor: 'pointer',
    opacity: 0,
    transition: 'all .5s ease',
    zIndex: 99,
  },
  isOpen: {
    left: 250,
    right: 0,
    opacity: 1
  },
  closeButton: {
    color: '#333',
    fontSize: 16,
    fontFamily: 'arial',
    fontWeight: 'bold',
    cursor: 'pointer',
    padding: 15,
  }
});